<template>
	<CardContent
		:class="cn(propertyCardContentVariants({ variant }), props.class)"
	>
		<BrokerAvatarInfo
			:class="cn(propertyCardBrokerVariants({ variant }), 'gap-9')"
			:info-classes="{
				wrapper: 'text-white',
				brokerName: 'text-[14px] leading-[20px]',
				companyName: 'text-[12px] leading-[18px]'
			}"
			avatar-shape="circle"
			avatar-class="h-[36px] w-[36px]"
			sizes="linear"
			:broker-src="brokerSrc || ''"
			:linear-sizes="true"
			:company-src="companyrSrc || ''"
			:broker-name="agentName"
			:company-name="property.company?.name"
		>
			<template #broker> {{ agentName }} </template>
			<template #company> {{ property.company?.name }} </template>
		</BrokerAvatarInfo>
	</CardContent>
</template>

<script setup lang="ts">
import type { PropertyCardContentProps } from '.';

import { cn } from '@/utils';
import { useImage } from '#imports';
import { getAgentName } from '~~/utils';
import { computed } from 'vue';

import { propertyCardBrokerVariants, propertyCardContentVariants } from '.';
import { BrokerAvatarInfo } from '../BrokerAvatarInfo';
import { CardContent } from '../ui/card';

const props = defineProps<PropertyCardContentProps>();

const getImageSrc = useImage();

const brokerSrc = computed(() =>
	getImageSrc(props.property.agent?.profilePicture.croppedUrl || '', {
		format: 'webp',
		width: 72
	})
);

const companyrSrc = computed(() =>
	getImageSrc(props.property.company?.smallLogo || '', {
		format: 'webp',
		width: 72
	})
);

const agentName = computed(() => getAgentName(props.property.agent));
</script>
